export const CALENDAR_QUERY_ROOTS = [
  "/api/calendar/agenda",
  "/api/calendar/call-actions",
  "/api/calendar/history",
  "/api/calendar/subscriptions",
  "/api/calendar/timeline",
  "/api/calendar/events",
] as const;

export const TIME_OFF_CALENDAR_QUERY_ROOTS = [
  "/api/time-off/calendar",
  "/api/time-off/company-holidays",
] as const;

export interface CalendarCacheInvalidator {
  invalidateQueries(options: { queryKey: readonly string[] }): Promise<unknown>;
}

/**
 * Browser-independent cache contract shared by the calendar hooks and the
 * websocket bridge. Keeping this module free of queryClient/browser imports
 * lets server-side and node tests consume the contract safely.
 */
export function invalidateCalendar(queryClient: CalendarCacheInvalidator) {
  return Promise.all(
    CALENDAR_QUERY_ROOTS.map((root) => queryClient.invalidateQueries({ queryKey: [root] })),
  );
}

export function invalidateTimeOffCalendarSources(queryClient: CalendarCacheInvalidator) {
  return Promise.all(
    TIME_OFF_CALENDAR_QUERY_ROOTS.map((root) =>
      queryClient.invalidateQueries({ queryKey: [root] })),
  );
}